(function () {
    'use strict';

    angular
        .module('iMatApp')
        .factory('productFactory', productFactory);

    productFactory.$inject = ['uuid2', 'guard'];

    function productFactory(uuid2, guard) {
        var factoryApi = {
            createDefault: createDefault,
            createByInfo: createByInfo
        };

        function Product(productTemplateId) {
            this.id = uuid2.newguid();
            this.state = 'Draft';

            this._material = null;
            this._colour = null;
            this._scale = 1;
            this._quantity = 1;
            this.productTemplateId = productTemplateId;

            this.model = {
                id: null,
                status: null,
                result: null,
                previewInfo: angular.undefined,// should be undefined. Because we will set null when preview info not available
                units: null,
                dimsMm: {
                    w: 0,
                    h: 0,
                    l: 0
                }
            };
        }

        Product.prototype = {
            material: materialGetSet,
            colour: colourGetSet,
            scale: scaleGetSet,
            quantity: quantityGetSet,

            isReady: isReady,
            isProcessing: isProcessing,

            getProductInfo: getProductInfo,

            isMaterialColourDraft: isMaterialColourDraft,
            setMaterialColour: setMaterialColour
        };

        return factoryApi;

        // ------------------------------------------ Public functions ---------------------------------------------------

        function createDefault(productTemplateId) {
            return new Product(productTemplateId);
        }

        function createByInfo(info) {
            var product = new Product(info.productTemplateId);

            if (info.modelId) {
                product.model.id = info.modelId;
            }

            if (info.materialId) {
                product._material = { id: info.materialId, isDraft: true };
            }

            if (info.colourId) {
                product._colour = { id: info.colourId, isDraft: true };
            }

            product._scale = info.scale || product._scale;
            product._quantity = info.quantity || product._quantity;

            return product;
        }

        // ---------------------------------------------------- API --------------------------------------------------

        function scaleGetSet(scale) {
            var product = this;

            if (angular.isUndefined(scale)) {
                return product._scale;
            }

            guard.argumentHasValue(scale, "scale");

            product._scale = scale;

            return angular.undefined;
        }

        function quantityGetSet(value) {
            var product = this;

            if (angular.isUndefined(value)) {
                return product._quantity;
            }

            guard.argumentHasValue(value, "quantity");

            product._quantity = value;

            return angular.undefined;
        }

        function isReady() {
            return this.state === 'Ready';
        }

        function isProcessing() {
            return this.state === 'ModelProcessing';
        }

        function materialGetSet(material) {
            var product = this;

            if (angular.isUndefined(material)) {
                return product._material;
            }

            guard.argumentHasValue(material, "material");
           
            product._material = material;
            product.colour(material.colours[0]);

            return angular.undefined;
        }

        function colourGetSet(colour) {
            var product = this;

            if (angular.isUndefined(colour)) {
                return product._colour;
            }

            guard.argumentHasValue(colour, "colour");

            product._colour = colour;

            return angular.undefined;
        }

        function setMaterialColour(material, colour) {
            var product = this;

            guard.argumentHasValue(material, "material");
            guard.argumentHasValue(colour, "colour");
           

            product._material = material;
            product._colour = colour;
        }

        function getProductInfo() {
            var self = this;

            var product = {
                modelId: self.model.id,
                materialId: self.material() ? self.material().id : null,
                colourId: self.colour() ? self.colour().id : null,

                scale: self.scale(),
                quantity: self.quantity(),
                productTemplateId: self.productTemplateId
            };

            return product;
        }

        function isMaterialColourDraft() {
            var product = this;
            if (!product._material) {
                return false;
            }

            return product._material.isDraft || (product._colour && product._colour.isDraft);
        }
    }
}());